import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import usePaymentFlowMachine from '../../../hooks/machines/usePaymentFlowMachine';
import PaymentFailed from '../../molecules/PaymentModalStates/PaymentFailed';
import PayoffPaymentConfirmation from '../../molecules/PaymentModalStates/payoffPayment/PayoffPaymentConfirmation';
import PayoffPaymentForm from '../../molecules/PaymentModalStates/payoffPayment/PayoffPaymentForm';
import PayoffPaymentReview from '../../molecules/PaymentModalStates/payoffPayment/PayoffPaymentReview';
const PayoffPayment = ({ resetTabFocus }) => {
    const [, payoffPaymentActor] = usePaymentFlowMachine();
    useEffect(() => {
        resetTabFocus();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [payoffPaymentActor.value]);
    if (payoffPaymentActor.matches('edit')) {
        return _jsx(PayoffPaymentForm, {});
    }
    if (payoffPaymentActor.matches('review')) {
        return _jsx(PayoffPaymentReview, {});
    }
    if (payoffPaymentActor.matches('success')) {
        return _jsx(PayoffPaymentConfirmation, {});
    }
    if (payoffPaymentActor.matches('error')) {
        return _jsx(PaymentFailed, {});
    }
    return null;
};
export default PayoffPayment;
